import apiClient from './client';

export const bookingAPI = {
  create: (data) => apiClient.post('/bookings', data),
  getMyBookings: () => apiClient.get('/bookings/my-bookings'),
  getById: (id) => apiClient.get(`/bookings/${id}`),
  start: (id) => apiClient.post(`/bookings/${id}/start`),
  complete: (id) => apiClient.post(`/bookings/${id}/complete`),
  update: (id, data) => apiClient.put(`/bookings/${id}`, data),
  cancel: (id, reason) => apiClient.delete(`/bookings/${id}`, { data: { reason } }),
  reschedule: (id, data) => apiClient.post(`/bookings/${id}/reschedule`, data),
  getAvailableSlots: (params) => apiClient.get('/bookings/available-slots', { params }),
  updateStatus: (id, status) => apiClient.put(`/bookings/${id}`, { status }),
  getBusinessStats: (businessId, period) => apiClient.get(`/bookings/stats/business/${businessId}`, { params: { period } }),
};
